import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "getPostingSlice",
  version: 1,
  storage,
  blacklist: [],
};

const initialState= {
    data:[],
    city:[
      {
          "id": 1,
          "name": "Los Angles",
          "created_at": "2023-05-12T13:12:49.967682Z",
          "updated_at": "2023-05-12T13:12:49.967682Z",
          "state": 1
      },
  ],
  state:[
    {
        "id": 1,
        "name": "LA",
        "created_at": "2023-05-12T13:12:34.919959Z",
        "updated_at": "2023-05-12T13:12:34.919959Z"
    },
   
]
  };

export const getPostingSlice = createSlice({
  name: "getPosting",
  initialState,
  reducers: {
    
    setPostData: (state, action) => {
        state.data=action.payload;
      },
     
  },
});

export const { setPostData} = getPostingSlice.actions;

export default persistReducer(persistConfig, getPostingSlice.reducer);
